module.exports = __webpack_public_path__ + "assets/img/e97f666a63c1dcd42ac9eb9dc38c734c.png";